import Styles from "./Styles/DownloadCard.module.css";
import img from "../../../Assets/Images/download background.png";
import React from "react";

const DownloadCard = React.forwardRef(
  ({ bookName, writerName, translatorName, text, pageNumber }, ref) => {
    function convertNumbersToPersian(text) {
      const persianNumbers = {
        0: "۰",
        1: "۱",
        2: "۲",
        3: "۳",
        4: "۴",
        5: "۵",
        6: "۶",
        7: "۷",
        8: "۸",
        9: "۹",
      };

      return text.replace(/[0-9]/g, function (match) {
        return persianNumbers[match];
      });
    }
    return (
      <div className={Styles.container} ref={ref}>
        <img src={img} alt="" />
        <div className={Styles.titleContainer}>
          <h1>نام مقاله : {bookName}</h1>
        </div>
        <div className={Styles.infosContainer}>
          <h3>ناشر : {writerName}</h3>
          {translatorName && <h3>نام مترجم : {translatorName}</h3>}
        </div>
        <p
          className={Styles.textContainer}
          dangerouslySetInnerHTML={{ __html: text }}
        ></p>
        {pageNumber !== null && (
          <h3 className={Styles.pageNumber}>
            شماره صفحه : {convertNumbersToPersian(pageNumber)}
          </h3>
        )}
      </div>
    );
  }
);

export default DownloadCard;
